export const default_job = {
  valid: false,
  cpu: 1,
  gpu: 0,
  max_retries: 0,
  memory_gb: 1,
  shared_memory_mb: 64,
  cpu_architecture_id: 1,
  cpu_architecture_name: 'x86',
  storage_gb: 1,
  description: null,
  docker_image: '',
  startup_command: '',
  project_id: null,
  project_name: '',
  job_definition_id: null,
  job_definition_name: '',
  location_group_name: '',
  location_group_id: 1,
  timeout_seconds: 86400,
  timeout_seconds_masked: '24:00:00',
  result_method_id: null,
  result_method_name: '',
  batch_descriptor: null,
  billing_identifier: null,
  prevent_preemption_name: 'No',
  prevent_preemption: false,
  batch_definition_item_name: '',
};

export const default_job_definition = {
  job_definition_name: '',
  docker_image: '',
  startup_command: '',
  description: null,
  location_group_id: 1,
  cpu_architecture_id: 1,
  cpu_architecture_name: 'x86',
  result_method_id: 1,
  timeout_seconds: 86400, // 24 hours
  max_retries: 0,
  stdout_success_text: null,
  billing_identifier: '',
  cpu: 1,
  gpu: 0,
  memory_gb: 1,
  shared_memory_mb: 64,
  storage_gb: 1,
  parameters: [],
};

export const legends = [
  { color: '#06C167', status: 'Connected', id: 1 },
  { color: '#F6F6F6', status: 'Not Used by Parent', id: 2 },
  { color: '#FF6937', status: 'Not Used by Child', id: 3 },
  { color: '#276EF1', status: 'Used by Other', id: 3 },
];

export const pin_color = {
  1: '#06C167',
  2: '#276EF1',
  3: '#FF6937',
  4: '#F6F6F6',
};
